<template>
  <div id="renta-bitacora">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-widget
            :title="'BITACORA DE LA RENTA ' + renta.folioRenta"
            color="primary darken-4"
            dark
          >
            <div slot="widget-content">
              <div>
                <v-layout row wrap>
                  <v-flex lg6>
                    <v-btn
                      color="success"
                      dark
                      fab
                      small
                      slot="activator"
                      @click="abrirDialogNuevoEvento"
                    >
                      <v-icon dark>add</v-icon>
                    </v-btn>

                    <form-bitacora-renta
                      :renta="renta"
                      :rentaBitacora="rentaBitacora"
                      :nuevoEvento="nuevoEvento"
                      ref="dialogBitacoraRenta"
                    ></form-bitacora-renta>
                  </v-flex>
                  <!-- <v-flex lg6 class="text-xs-right">
                    <h4>
                      <span class="green--text">$ {{ formatMoney(renta.pagado) }}</span>
                      / $ {{ formatMoney(renta.totalFinal) }}
                    </h4>
                  </v-flex>-->
                </v-layout>
              </div>

              <v-layout row wrap>
                <v-flex lg12>
                  <v-card>
                    <v-card-text class="pa-0">
                      <v-data-table
                        :headers="eventosRenta.headers"
                        :items="eventosRenta.data"
                        v-bind:pagination.sync="eventosRenta.pagination"
                        class="elevation-1"
                        item-key="eventoRentaId"
                      >
                        <template slot="items" slot-scope="props">
                          <td>{{ props.item.fechaEvento.substring(0, 10) }}</td>
                          <td>{{ props.item.nombreEvento }}</td>
                          <td>{{ props.item.comentarios }}</td>
                          <td>{{ props.item.anexoEvento }}</td>
                          <td class="text-xs-center">
                            <v-btn
                              depressed
                              outline
                              icon
                              fab
                              dark
                              color="pink"
                              small
                              @click="deleteEvento(props.item)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </td>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </div>
          </v-widget>
        </v-flex>
      </v-layout>
      <v-alert
        :value="$store.state.operationFailed"
        color="error"
        icon="warning"
        transition="scale-transition"
      >
        <span v-html="$store.state.errorMessage"></span>
      </v-alert>
    </v-container>

    <confirm ref="confirm"></confirm>

    <snack-bar></snack-bar>

    <loading-alert></loading-alert>
  </div>
</template>

<script>
import VWidget from "@/components/VWidget";
import formBitacoraRenta from "./FormBitacoraRenta";

import confirm from "@/components/dialogs/Confirm";
import loadingAlert from "@/components/LoadingAlert";
import snackBar from "@/components/SnackBar";

import moment from "moment";

//Services
import rentaBitacoraService from "@/services/rentaBitacoraService";

export default {
  components: {
    VWidget,
    formBitacoraRenta,
    confirm,
    loadingAlert,
    snackBar,
  },
  props: {
    renta: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      eventosRenta: {
        headers: [
          { text: "FECHA Y HORA", align: "center", value: "fechaEvento" },
          { text: "EVENTO", align: "center", value: "nombreEvento" },
          { text: "COMENTARIOS", align: "center", value: "comentarios" },
          { text: "ANEXO", align: "center", value: "anexoEvento" },
          {
            text: "ACCIONES",
            align: "center",
            value: "acciones",
            align: "right",
          },
        ],
        data: [],
        pagination: { sortBy: "numPago", descending: true, rowsPerPage: -1 },
      },
      rentaBitacora: {
        rentaId: this.renta.rentaId,
        eventoRentaId: 0,
        fechaEvento: moment(new Date()).format("YYYY-MM-DD"),
        comentarios: "",
        anexoEvento: "",
      },
      nuevoEvento: true,
    };
  },
  watch: {
    renta: function (renta) {
      this.getEventos();
    },
  },
  methods: {
    abrirDialogNuevoEvento() {
      this.$store.state.tituloForm = "AGREGAR EVENTO RENTA";
      this.$store.state.iconoForm = "/images/general/agregar-40.png";
      this.$refs.dialogBitacoraRenta.resetForm();
      this.$refs.dialogBitacoraRenta.openDialog();
      this.nuevoEvento = true;
    },
    getEventos() {
      let self = this;
      self.$store.state.loadingInfo.show = true;
      rentaBitacoraService
        .getBitacora(self.renta.rentaId)
        .then((result) => {
          self.eventosRenta.data = result;
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.$store.state.loadingInfo.show = false;
        });
    },
    deleteEvento(eventoRenta) {},
  },
};
</script>
